var _path, _path2, _g, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1576,
    height: 1549,
    viewBox: "0 0 1576 1549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M838.846 984.051C842.32 982.984 845.785 981.817 849.237 980.551C881.736 968.632 909.332 949.253 930.792 925.067C917.648 933.455 903.399 940.562 888.155 946.153C872.616 951.851 856.85 955.68 841.102 957.754L838.846 984.051Z",
    fill: "url(#paint0_linear_1_50)",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M815.617 959.595C725.447 960.798 640.342 905.815 607.583 816.495C594.116 779.774 591.15 741.76 597.162 705.735C575.012 752.768 570.953 808.255 590.249 860.867C624.191 953.414 719.015 1006.03 812.994 990.181L815.617 959.595Z",
    fill: "url(#paint1_linear_1_50)",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_1_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.694 813.56C596.558 813.612 598.429 813.638 600.306 813.638C638.901 813.638 674.908 802.58 705.321 783.466C717.771 847.419 774.192 895.7 841.913 895.7C897.337 895.7 945.193 863.361 967.57 816.557C969.305 815.642 971.018 814.692 972.708 813.706C948.253 894.747 872.895 953.775 783.723 953.775C694.497 953.775 619.102 894.676 594.694 813.56Z",
    fill: "url(#paint2_radial_1_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.694 813.56C596.558 813.612 598.429 813.638 600.306 813.638C638.901 813.638 674.908 802.58 705.321 783.466C717.771 847.419 774.192 895.7 841.913 895.7C897.337 895.7 945.193 863.361 967.57 816.557C969.305 815.642 971.018 814.692 972.708 813.706C948.253 894.747 872.895 953.775 783.723 953.775C694.497 953.775 619.102 894.676 594.694 813.56Z",
    fill: "#04171E",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.64 816.614C597.191 816.65 598.746 816.668 600.305 816.668C639.133 816.668 675.343 805.476 705.871 786.149C719.356 848.765 775.143 895.7 841.913 895.7C897.337 895.7 945.193 863.36 967.57 816.557C969.305 815.642 971.018 814.691 972.708 813.706C948.253 894.746 872.895 953.775 783.723 953.775C695.621 953.775 621.003 896.155 595.64 816.614Z",
    fill: "url(#paint3_radial_1_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.64 816.614C597.191 816.65 598.746 816.668 600.305 816.668C639.133 816.668 675.343 805.476 705.871 786.149C719.356 848.765 775.143 895.7 841.913 895.7C897.337 895.7 945.193 863.36 967.57 816.557C969.305 815.642 971.018 814.691 972.708 813.706C948.253 894.746 872.895 953.775 783.723 953.775C695.621 953.775 621.003 896.155 595.64 816.614Z",
    fill: "#04171E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.085 891.226C849.027 914.516 812.958 928.523 773.611 928.523C700.163 928.523 638.137 879.717 618.317 812.829C650.091 809.959 679.692 799.573 705.32 783.466C717.77 847.419 774.192 895.7 841.912 895.7C854.063 895.7 865.851 894.146 877.085 891.226Z",
    fill: "url(#paint4_linear_1_50)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.65 756.825C945.65 846.074 873.156 918.425 783.73 918.425C694.304 918.425 621.81 846.074 621.81 756.825C621.81 667.576 694.304 595.225 783.73 595.225C873.156 595.225 945.65 667.576 945.65 756.825Z",
    fill: "url(#paint5_radial_1_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.886 726.481C934.886 789.234 883.914 840.106 821.036 840.106C758.159 840.106 707.186 789.234 707.186 726.481C707.186 663.727 758.159 612.856 821.036 612.856C883.914 612.856 934.886 663.727 934.886 726.481Z",
    fill: "url(#paint6_radial_1_50)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.346 613.06C791.807 612.924 789.249 612.856 786.676 612.856C762.453 612.856 739.654 618.938 719.727 629.656C730.384 627.313 741.457 626.077 752.82 626.077C764.401 626.077 775.682 627.361 786.528 629.793L794.346 613.06Z",
    fill: "url(#paint7_linear_1_50)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.714 634.724C863.244 655.66 905.908 712.289 905.908 778.863C905.908 806.233 898.697 831.922 886.067 854.141C911.952 828.579 927.988 793.102 927.988 753.888C927.988 684.909 878.368 627.495 812.807 615.262L803.714 634.724Z",
    fill: "url(#paint8_linear_1_50)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.261 893.441C845.231 909.266 815.552 918.428 783.73 918.428C733.298 918.428 688.25 895.417 658.554 859.341C666.74 860.838 675.177 861.62 683.797 861.62C746.387 861.62 799.325 820.378 816.817 763.638C822.588 764.144 828.43 764.403 834.333 764.403C874.77 764.403 912.366 752.264 943.663 731.439C944.971 739.71 945.65 748.19 945.65 756.828C945.65 762.189 945.388 767.49 944.877 772.718C935.782 821.743 908.492 864.396 870.261 893.441Z",
    fill: "url(#paint9_linear_1_50)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.745 813.704C619.198 894.748 694.558 953.78 783.733 953.78C892.301 953.78 980.391 866.28 981.069 758.086C970.238 758.018 959.614 757.079 949.264 755.336C924.94 766.035 898.042 771.975 869.754 771.975C859.944 771.975 850.302 771.261 840.877 769.881C823.405 826.654 770.451 867.927 707.837 867.927C664.175 867.927 625.21 847.858 599.698 816.457C598.027 815.572 596.376 814.654 594.745 813.704Z",
    fill: "url(#paint10_linear_1_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.068 758.258C952.043 775.013 918.345 784.603 882.403 784.603C875.553 784.603 868.785 784.255 862.114 783.575C849.623 847.476 793.226 895.703 725.543 895.703C670.119 895.703 622.263 863.364 599.886 816.56C598.151 815.645 596.438 814.694 594.748 813.709C619.203 894.75 694.561 953.778 783.733 953.778C892.243 953.778 980.298 866.372 981.068 758.258Z",
    fill: "url(#paint11_radial_1_50)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.68 765.791C954.793 771.402 942.255 775.863 929.209 779.03C927.517 793.412 924.265 807.834 919.348 822.087C907.362 856.826 886.96 886.286 861.201 908.979C905.248 887.824 941.137 849.791 958.309 800.018C962.219 788.684 964.989 777.234 966.68 765.791Z",
    fill: "url(#paint12_linear_1_50)",
    fillOpacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M840.793 770.221C841.016 769.923 841.431 769.868 841.721 770.097C848.309 775.312 855.427 779.912 863.058 783.815C863.385 783.982 863.519 784.391 863.356 784.728C863.193 785.064 862.796 785.202 862.469 785.034C854.76 781.092 847.568 776.444 840.914 771.176C840.624 770.946 840.57 770.519 840.793 770.221Z",
    fill: "url(#paint13_linear_1_50)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M791.836 549.329C787.725 549.11 783.585 549 779.42 549C740.211 549 703.307 558.784 671.053 576.024C688.303 572.255 706.226 570.267 724.618 570.267C743.365 570.267 761.625 572.332 779.18 576.244L791.836 549.329Z",
    fill: "url(#paint14_linear_1_50)",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M806.999 584.175C903.358 617.851 972.416 708.939 972.416 816.024C972.416 860.049 960.744 901.37 940.301 937.109C982.199 895.992 1008.16 838.928 1008.16 775.852C1008.16 664.898 927.838 572.548 821.718 552.871L806.999 584.175Z",
    fill: "url(#paint15_linear_1_50)",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.26 777.264C1028.26 913.533 917.795 1024 781.526 1024C645.258 1024 534.791 913.533 534.791 777.264C534.791 640.996 645.258 530.528 781.526 530.528C917.795 530.528 1028.26 640.996 1028.26 777.264Z",
    fill: "url(#paint16_linear_1_50)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_1_50",
    x: -59.9063,
    y: -72.4317,
    width: 1694.86,
    height: 1693.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.07657
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.47451 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_50"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1531
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.47451 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_50",
    result: "effect2_dropShadow_1_50"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.536
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.47451 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1_50",
    result: "effect3_dropShadow_1_50"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 99.072
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.47451 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1_50",
    result: "effect4_dropShadow_1_50"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 169.838
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.47451 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1_50",
    result: "effect5_dropShadow_1_50"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 297.216
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.47451 0 0 0 0 0.513726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_1_50",
    result: "effect6_dropShadow_1_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_1_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_50",
    x1: 684.633,
    y1: 944.769,
    x2: 872.682,
    y2: 764.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_50",
    x1: 684.633,
    y1: 944.769,
    x2: 872.682,
    y2: 764.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_50",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(972.708 912.175) rotate(179.948) scale(1432.85 4155.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_50",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(972.708 912.175) rotate(179.948) scale(1432.85 4155.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#24537E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_50",
    x1: 872.246,
    y1: 955.748,
    x2: 807.393,
    y2: 617.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_50",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(665.234 883.167) rotate(-57.4888) scale(284.834 4130.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_50",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(934.265 612.9) rotate(144.321) scale(280.317 278.152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906332,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_50",
    x1: 886.195,
    y1: 676.025,
    x2: 719.321,
    y2: 748.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_50",
    x1: 886.195,
    y1: 676.025,
    x2: 719.321,
    y2: 748.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_50",
    x1: 1196.14,
    y1: 330.719,
    x2: 514.31,
    y2: 899.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_50",
    x1: 908.965,
    y1: 782.706,
    x2: 652.914,
    y2: 873.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E6585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04171E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_50",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(646.55 932.449) rotate(-38.508) scale(233.379 3638.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_50",
    x1: 967.155,
    y1: 765.662,
    x2: 868.914,
    y2: 914.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_50",
    x1: 863.292,
    y1: 784.388,
    x2: 831.302,
    y2: 764.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_50",
    x1: 940.509,
    y1: 650.608,
    x2: 670.941,
    y2: 769.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_50",
    x1: 940.509,
    y1: 650.608,
    x2: 670.941,
    y2: 769.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732381,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_50",
    x1: 978.137,
    y1: 636.843,
    x2: 589.45,
    y2: 910.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1CC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbon);
export default __webpack_public_path__ + "static/media/carbon.96c5ee91.svg";
export { ForwardRef as ReactComponent };